export const CHECKLIST_TYPES = [
  'job',
  'opportunity',
  'asset',
];